import React from 'react';
import {
    SimpleForm,
    Edit,
    required,
    ReferenceField,
    TextField, BooleanInput,
} from 'react-admin';
import { redirectToReglaTab } from '../regla/regla-utils';
const redirectToReglaEditEtiquetaTab = (basePath, id, data) => redirectToReglaTab(data.idRegla, 'etiqueta');

const ReglaEtiquetaEdit = (props) => (
    <Edit {...props}>
        <SimpleForm redirect={redirectToReglaEditEtiquetaTab}>
            <ReferenceField
                source="idRegla"
                reference="regla"
                link={false}
            >
                <TextField source="descripcion" />
            </ReferenceField>
            <ReferenceField
                source="idEtiqueta"
                reference="etiquetas"
                label="resources.regla-etiqueta.fields.idEtiqueta"
                sort={{ field: "descripcion", order: "ASC" }}
                perPage={100}
                filterToQuery={(searchText) => ({
                    descripcion: searchText ? searchText : "",
                })}
                validate={[required()]}
            >
                <TextField source="descripcion"/>
            </ReferenceField>
            <BooleanInput source="excluye" defaultValue={false}/>
        </SimpleForm>
    </Edit>
);

export default ReglaEtiquetaEdit;
